import Section from "./Section";
import Fields from "./Fields";
import Field from "./Field";
import Actions from "./Actions";

Section.Field = Field;
Section.Fields = Fields;
Section.Actions = Actions;

export default Section;
